const DeleteIcon = () => {
  return (
    <svg viewBox="0 0 14.21 16.319">
      <g transform="translate(-78.732 -47.366)">
        <path d="M84.418,47.366a.708.708,0,0,0-.507.205.716.716,0,0,0-.213.5H79.452a.71.71,0,1,0,0,1.419H92.223a.71.71,0,1,0,0-1.419H87.977a.716.716,0,0,0-.213-.5.708.708,0,0,0-.507-.205Zm-4.966,3.548V62.266a1.418,1.418,0,0,0,1.419,1.419H90.8a1.418,1.418,0,0,0,1.419-1.419V50.913Z" />
      </g>
    </svg>
  );
};

export default DeleteIcon;
